/* eslint-disable max-len */
import { FC, useState } from 'react';

import Slider from 'react-slick';
import classNames from 'classnames';

import { Image } from '@/components';
import { Product } from '@/types';

interface IProductImagesProps {
  product: Product;
}

const ProductImages: FC<IProductImagesProps> = ({ product }) => {
  const [pictureSlideIndex, setPictureSlideIndex] = useState(0);
  const [load, setLoad] = useState(true);
  const stockPhoto = product?.asset?.stock ?? false;

  const REVERSE_PROXY_LINK = process.env.NEXT_PUBLIC_REVERSE_PROXY_LINK ?? '';

  const loaderImage = ({ src, width, quality }) => {
    return `${src}?w=${width}&q=${quality || 75}`;
  };

  return (
    <div className={'details__images'}>
      <Slider
        arrows={true}
        beforeChange={(_, next) => {
          setPictureSlideIndex(next);
        }}
        centerMode={false}
        centerPadding={'8px'}
        cssEase="linear"
        customPaging={i => {
          return (
            <figure key={`pagination-${i}`}>
              <Image
                alt={product.name ?? 'Product image'}
                fallback={`${REVERSE_PROXY_LINK}/images/product-placeholder.svg`}
                height={90}
                id={product?.id as string}
                sizes="(min-width: 1024px) 90px, 70px"
                src={product?.assets?.[i].image as string}
                width={90}
              />
            </figure>
          );
        }}
        dots={true}
        dotsClass={'slick-thumb'}
        fade={true}
        infinite={false}
        initialSlide={0}
        key={product?.id}
        slidesToScroll={1}
        slidesToShow={1}
        speed={500}
      >
        {product?.assets?.map((asset, i) => (
          <figure
            className={classNames('slide_main', {
              ['slide_main__load']: load,
            })}
            hidden={pictureSlideIndex !== i ? true : undefined}
            key={`image-${i}`}
          >
            <Image
              alt={product.name ?? 'Product image'}
              blurDataURL={
                "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1' viewBox='0 0 1 1'%3E%3Crect fill='#dedede' /%3E%3C/svg%3E\")"
              }
              fallback={`${REVERSE_PROXY_LINK}/images/product-placeholder.svg`}
              fill
              id={product.id!}
              loader={loaderImage}
              onLoad={() => {
                setLoad(false);
              }}
              placeholder="blur"
              priority
              quality={100}
              //sizes="(min-width: 2048px) 468px, (min-width: 1536px) 464px, (min-width: 1280px) 408px, (min-width: 1024px) 438px, (min-width: 768px) 310px, (min-width: 640px) 600px, 100wv"
              src={asset?.image!}
            />
            {stockPhoto && (
              <span className="product__in_stock">Stock photo</span>
            )}
          </figure>
        ))}
      </Slider>
    </div>
  );
};

export { ProductImages };
